import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DropdownList } from 'react-widgets';
import { translate, getLanguages } from '../../../../services';
import { PropTypes } from 'prop-types';
import { AccessoryConfigurator, AccessoryProductList } from '..';
import { configurationSource, deflateModelVariables, getPreselectionAssignments, TranslationService, getTranslationModelName } from '../../../../util';
import { 
  combineDispatchers,
  combineStates,
  configuratorDispatcher,
  configuratorState,
  filterDispatcher,
  filterSelectorState,
  pageresultState,
  pinnedItemsState,
  identityState,
  screenSizeState,
  currentPageState,
  currentPageDispatcher,
  flagState,
  flagDispatcher,
  productState,
  currentNodeState
} from '../../../../store';
import { BusyContainer } from '../../../../components';
import $ from 'jquery';
import SelectFilterMessage from './SelectFilterMessage';
import { GreyFilterEmptyIconNew } from '../../../../../style/images';

const deadValues = ['not applicable', 'not&#032;applicable', 'do not display'];

const containValidValues = variable => {
  return variable.values
    .any( value => value.state !== 4 && !deadValues.includes( value.title.toLocaleLowerCase( 'en-US' ) ) )
};

const containValidValuesFirst = variable => {
  return variable.values
    .any( value => !deadValues.includes( value.title.toLocaleLowerCase( 'en-US' ) ) )
}
export class AccessoryConfiguratorPageComponent extends Component {
  constructor() {
    super();
    this.state = {
      selectedProduct: {
        name: null
      },
      height: window.innerHeight,
      breadCrumbHeight: 0,
      type: null,
    };
  }

  updateDimensions = () => {
    this.setState({height: window.innerHeight, breadCrumbHeight: $('#product-breadcrumb-header').height()});
  };

  componentDidMount() {
    const { currentSelector, user } = this.props;
    currentSelector && this.props.getFilterSelectors( currentSelector, user ).then( () => {
      const { pageresult } = this.props;
      pageresult?.totalItems === 1 && this.updateSelectedProduct( pageresult.results.first() );
    } );
    if(this.state.breadCrumbHeight===0){
      this.setState({breadCrumbHeight:$('#product-breadcrumb-header').height()})
    }
    window.addEventListener('resize', this.updateDimensions);
  }

  componentDidUpdate( _, prevState ) {
    const { selectedProduct } = this.state;
    if ( prevState.selectedProduct.name !== selectedProduct.name ) {
      this.resetConfiguration( this.props, this.state );
    }
  }
  
  componentWillUnmount(){
    const btn = $('.reset-button')[0];
    if(btn) {
      btn.style.display = "flex"
    }
    window.removeEventListener('resize', this.updateDimensions);
  }
  setPreselectedValues( configuration, pinnedAssignments = [], preSelectionAssignments = [] ) {
    if( !configuration ) {
      return null;
    }

    return this.fromTemplate( configuration, [...configuration.assignments, ...pinnedAssignments, ...preSelectionAssignments] );
  }

  setPreselectionAssignments( configuration, pinnedAssignments = [], preSelectionAssignments = [] ) {
    if( !configuration ) {
      return null;
    }

    return this.fromTemplate( configuration, [...configuration.assignments, ...pinnedAssignments, ...preSelectionAssignments] );
  }
  
  getPinnedValues( configuration, pinnedValues ) {
    const variables = deflateModelVariables( configuration.model );
    const assignments = [];
    for( let variable of variables ) {
      for( let pinnedVariable in pinnedValues ) {
        if( variable.name === pinnedVariable ) {
          const value = Object.keys( pinnedValues[pinnedVariable] ).first();
          assignments.push( { key: `${variable.group}.${variable.name}`, value } );
        }
      }
    }

    return assignments;
  }
  
  getConfiguration() {
    const { configurations } = this.props;
    const { selectedProduct } = this.state;
    return configurations[selectedProduct.name] && configurations[selectedProduct.name][0];
  }
  
  resetConfiguration( props, state ) {
    const { modelToLoad } = props;
    const { selectedProduct } = state;
    const model = modelToLoad || selectedProduct.modelToLoad;

    const loadProduct = model
      ? this.props.loadComplexProduct( selectedProduct, model )
      : this.props.loadProduct( selectedProduct );

    loadProduct.then( () => {
      const { configurations, currentSelector, pinnedItems } = this.props;
      const { selectedProduct } = this.state;
      const configuration = configurations[selectedProduct.name] && configurations[selectedProduct.name][0];
      const pinnedAssignments = pinnedItems && pinnedItems[selectedProduct.name] && this.getPinnedValues( configuration, pinnedItems[selectedProduct.name] );
      const preSelectionAssignments = getPreselectionAssignments( configuration, currentSelector ) || [];

      if( selectedProduct.configuration ) {
        return this.setPreselectedValues( selectedProduct.configuration, pinnedAssignments, preSelectionAssignments );
      }

      return this.setPreselectionAssignments( configuration, pinnedAssignments, preSelectionAssignments );
    } );
  }

  getConfigurationSource() {
    const configuration = this.getConfiguration();
    return configuration.productModelType === 0 ? configurationSource.model : configurationSource.accessories;
  }

  fromTemplate( template, assignments ) {
    if( !assignments || !assignments.length ) {
      return Promise.resolve( template );
    }
    return this.props.fromTemplate( this.getConfiguration(), template, assignments );
  }

  assignValue = ( variable, value, fqn ) => {
    const template = this.getConfiguration();
    const source = this.getConfigurationSource();
    return this.props.assignValue( { ...template }, template, source === configurationSource.model ? fqn : variable, value );
  }

  removeValue = ( variable, value, fqn ) => {
    const template = this.getConfiguration();
    const source = this.getConfigurationSource();
    return this.props.removeValue( { ...template }, template, source === configurationSource.model ? fqn : variable, value );
  }

  updateSelectedProduct = product => {
    this.setState( { selectedProduct: product } );
  }

  renderConfigurator( configuration, contentHeight ) {
    if( configuration ) {
      const translationService = TranslationService( getTranslationModelName( configuration ), 'model' )( getLanguages().first() );
      const variables = deflateModelVariables( translationService.withGroups( configuration.model ) );

      const {template} = this.props.configurations;
      let allFilters = []
      if(template){
        const templateVariables = deflateModelVariables( translationService.withGroups( template.model ) );
        allFilters = templateVariables.filter( variable => variable.name && variable.show && containValidValues  ( variable ) ).filter( variable => variable.properties.IsBomItem )
      }

      let typeTwoFilter = variables.filter( variable => variable.name && variable.show && containValidValues( variable ) ).filter( variable => variable.properties.IsBomItem )
      if ( configuration.productModelType === 1) {
        return <AccessoryProductList resetHeader={this.props.resetHeader} setShowResetHeader={this.props.setShowResetHeader} variables={ variables} materialKey={configuration.materialKey  }
        />;
      }
      if ( configuration.productModelType === 0 && configuration.materialKey === this.props.currentNode.customProperties.keyword ) {
        return <AccessoryProductList resetHeader={this.props.resetHeader} setShowResetHeader={this.props.setShowResetHeader} variables={ variables} materialKey={configuration.materialKey  }
        />;
      }
      // type - 2
       if ( configuration.productModelType === 0 ) {
        if(allFilters.length>0){
          this.props.hideResetHeader && this.props.hideResetHeader()
        }
        else{
          this.props.setShowResetHeader && this.props.setShowResetHeader()
        }
        return <AccessoryConfigurator
           name={ configuration.materialKey }
           variables={ variables }
           assignValue={ this.assignValue }
           removeValue={ this.removeValue }
           filterType = {allFilters.length>0 || typeTwoFilter.length>0?2:4}
           typeTwoFilter = {typeTwoFilter}
           contentHeight = {contentHeight}
           resetHeader = {this.props.resetHeader}
           currentSelector={ this.props.currentSelector}
         />;
       }
       // type 1
       if ( configuration.productModelType === 1 ) {
        const { selectedProduct, height, breadCrumbHeight } = this.state;
        let contentHeight = height-breadCrumbHeight-50-72-48;
         return <AccessoryProductList variables={ variables } contentHeight={contentHeight} currentSelector = {this.props.currentSelector}/>;
       }
    }
    return <SelectFilterMessage
      heading="No data found."
      message="There are no accessories found for your request."
      icon={GreyFilterEmptyIconNew}
    />

    ;
  }
  hideResetBtn () {
    const btn = $('.reset-button')[0];
    if(btn) {
      btn.style.display = "none"
    }
  }

  render() {
    const { currentSelector, pageresult } = this.props;
    const { selectedProduct, height, breadCrumbHeight } = this.state;
    let contentHeight = height-breadCrumbHeight-49-71-26+"px";
    const configuration = this.getConfiguration();

    if( !pageresult || pageresult.totalItems !== 0 && selectedProduct.name && !configuration ) {
      if(!this.props.flags.isBusy){
        this.props.busy()
      }
      return <BusyContainer className="accessory-configurator-loading" isBusy/>;
    }
    if(this.props.flags.isBusy){
      this.props.notBusy()
    }
 

    return pageresult.totalItems <= 1 ? (
      // typw 2 OR 4
      this.renderConfigurator(configuration, contentHeight)
    ) : (
      // type 1
      <div
        className="accessory-selection"
        style={{
          height:
            selectedProduct.name &&
            [1, 2].includes(configuration.productModelType)
              ? "100%"
              : contentHeight,
        }}
      >
        {this.props.hideResetHeader && this.props.hideResetHeader()}
        <div className="selection-field">
          <span className="label">{translate(currentSelector.name)}</span>
          <DropdownList
            data={pageresult.results.where((r) => r.name).select()}
            textField="name"
            value={selectedProduct.name}
            onChange={this.updateSelectedProduct}
            placeholder={translate("Select...")}
          />
        </div>
        {selectedProduct.name ? (
          this.renderConfigurator(configuration, contentHeight)
        ) : (
          // if no item selected, then showing below section
          <SelectFilterMessage
          forMobile = {{heading:"No data found.", message:"Please select filters at the top first to see the accessories"}}
          forDesktop = {{heading:null, message:"Please select filters at the top first to see the accessories"}}
          icon={GreyFilterEmptyIconNew} />
        )}
      </div>
    );
  }
}

AccessoryConfiguratorPageComponent.propTypes = {
  assignValue: PropTypes.func.isRequired,
  configurations: PropTypes.objectOf( PropTypes.shape( {
    productModelType: PropTypes.number
  } ) ),
  currentSelector: PropTypes.shape( {
    name: PropTypes.string.isRequired
  } ), 
  fromTemplate: PropTypes.func.isRequired,
  getFilterSelectors: PropTypes.func.isRequired,
  loadComplexProduct: PropTypes.func.isRequired,
  loadProduct: PropTypes.func.isRequired,
  pageresult: PropTypes.shape( {
    results: PropTypes.array,
    totalItems: PropTypes.number.isRequired
  } ),
  pinnedItems: PropTypes.shape( {} ),
  removeValue: PropTypes.func.isRequired
};

export const AccessoryConfiguratorPage = name => connect(
  combineStates( identityState,currentPageState,flagState, configuratorState, filterSelectorState( 'selector' )( name ), pageresultState( 'products' )( name ), pinnedItemsState, screenSizeState,productState,currentNodeState ),
  combineDispatchers( configuratorDispatcher,flagDispatcher ,currentPageDispatcher, filterDispatcher )
)( AccessoryConfiguratorPageComponent );
